import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ContentChild,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  Input,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { CarouselNavigationComponent } from '../carousel-navigation/carousel-navigation.component';
import { UpcomingPropertyCardComponent } from '../../cards/upcoming-property-card/upcoming-property-card.component';

@Component({
  selector: 'app-upcoming-property-carousel',
  standalone: true,
  imports: [CommonModule, CarouselNavigationComponent, UpcomingPropertyCardComponent],
  templateUrl: './upcoming-property-carousel.component.html',
  styleUrl: './upcoming-property-carousel.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UpcomingPropertyCarouselComponent {
  private platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  @Input() upcomingProperties: any[] = [];
  @ViewChild('swiperCardsContainer', { static: false })
  swiperContainer!: ElementRef;
  swiperInstance!: any;
  hideExploreNowBtn: boolean = false;
  currentIndex: number = 1;
  @ContentChild('navigationLeftContent')
  navigationLeftContent!: TemplateRef<any>;
  private cdr = inject(ChangeDetectorRef);
  breakpoints: any = {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    480: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    1180: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  };
  hasNavigationContent: boolean = false;
  @Input() swiperConfig: SwiperOptions = {
    init: true,
    slidesPerView: 2.1,
    loop: false,
    spaceBetween: 10,
    centeredSlides: false,
    mousewheel: {
      forceToAxis: true,
      thresholdTime: 500,
      thresholdDelta: 50,
    },
    breakpoints: this.breakpoints,
    grabCursor: false,
    freeMode: false,
    shortSwipes: true,
    longSwipes: true,
    pagination: {
      clickable: true, // Makes the pagination dots clickable
      dynamicBullets: true, // Optional: for dynamic bullet resizing
    },
  };

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initSwiper();
      this.cdr.detectChanges();
    }
    if (this.navigationLeftContent) {
      this.hasNavigationContent = true;
    }
  }

  initSwiper() {
    Object.assign(this.swiperContainer.nativeElement, this.swiperConfig);
    this.swiperContainer.nativeElement.initialize();
    this.swiperInstance = this.swiperContainer.nativeElement.swiper;
  }
  onPanelClick(index: number) {
    this.currentIndex = index;
  }

}
